import { LinearProgress } from "@mui/material";
import { createBrowserRouter } from "react-router-dom";

import { AppShell } from "@/components/AppShell";
import { ErrorPage } from "@/components/ErrorPage";
import { NotFoundPage } from "@/components/NotFoundPage";
import { assetsRoute } from "@/features/assets/route";
import { calendarRoute } from "@/features/calendar/route";
import { dashboardRoute } from "@/features/dashboard/route";
import { loginRoute } from "@/features/login/route";
import { weatherForecastRoute } from "@/features/weatherForecast/route";
import { welcomeRoute } from "@/features/welcome/route";
import { workOrdersRoutes } from "@/features/workOrders/route";

export const router = createBrowserRouter([
    {
        ...welcomeRoute,
        errorElement: <ErrorPage />,
        hydrateFallbackElement: <LinearProgress />,
    },
    {
        element: <AppShell />,
        errorElement: <ErrorPage />,
        hydrateFallbackElement: <LinearProgress />,
        children: [
            dashboardRoute,
            loginRoute,
            assetsRoute,
            calendarRoute,
            ...workOrdersRoutes,
            weatherForecastRoute,
            { path: "*", element: <NotFoundPage /> },
        ],
    },
]);
